/**
 * @desc 导出供应商采购订单列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierPurchaseOrder.exportSupplierPurchaseOrder.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/purchaseOrder/exportSupplierPurchaseOrder`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
